export const Mark = ({ className = "h-8 w-8" }) => (
  <img src="/assets/jh-sun-mark.png" alt="" aria-hidden="true" className={`${className} object-contain`} />
);
